'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Settings = function Settings(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        '--'
      ),
      _react2.default.createElement('path', { d: 'M12 13.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm-.025-3.923a2.436 2.436 0 1 0 2.436 2.435 2.436 2.436 0 0 0-2.436-2.435zm5.492 3.41a.998.998 0 0 0-.748.652 5.063 5.063 0 0 1-.224.537c-.154.319-.129.696.067.991l.869 1.302-.962.962-1.302-.868a1.002 1.002 0 0 0-.99-.068 5.188 5.188 0 0 1-.537.224 1 1 0 0 0-.653.748L12.68 19h-1.36l-.306-1.533a1 1 0 0 0-.653-.748 4.977 4.977 0 0 1-.537-.224.997.997 0 0 0-.991.068l-1.302.868-.962-.962.869-1.302c.195-.295.221-.671.067-.99a5.435 5.435 0 0 1-.224-.538 1 1 0 0 0-.748-.652l-1.532-.307L5 11.32l1.533-.307a.996.996 0 0 0 .748-.652 5.28 5.28 0 0 1 .224-.537 1 1 0 0 0-.067-.991l-.869-1.302.962-.962 1.302.868a1.002 1.002 0 0 0 .99.068c.173-.084.353-.159.538-.224.334-.116.582-.401.652-.748L11.32 5h1.36l.307 1.533c.07.347.318.632.652.748.184.065.364.139.537.224a1 1 0 0 0 .991-.068l1.302-.868.962.962-.869 1.302a1.004 1.004 0 0 0-.067.99c.084.174.159.353.224.538.116.334.401.582.748.652L19 11.32v1.36l-1.533.307zm1.729-2.648l-1.533-.307a6.182 6.182 0 0 0-.267-.644l.867-1.302a1 1 0 0 0-.125-1.262l-.962-.962a1 1 0 0 0-1.262-.125l-1.302.868a5.978 5.978 0 0 0-.644-.268l-.307-1.533A1.001 1.001 0 0 0 12.68 4h-1.36c-.476 0-.887.336-.981.804l-.307 1.533a5.978 5.978 0 0 0-.644.268l-1.302-.868a1.002 1.002 0 0 0-1.262.125l-.962.962a1 1 0 0 0-.125 1.262l.868 1.302a5.91 5.91 0 0 0-.268.645l-1.532.306A1.001 1.001 0 0 0 4 11.32v1.36c0 .477.337.887.805.981l1.532.307c.077.221.167.436.268.644l-.868 1.302a1 1 0 0 0 .125 1.262l.962.962a1.001 1.001 0 0 0 1.262.125l1.302-.868c.209.101.424.191.645.268l.306 1.533c.094.468.505.804.981.804h1.36c.476 0 .887-.336.981-.804l.307-1.533c.221-.077.436-.167.644-.268l1.302.868a1 1 0 0 0 1.262-.125l.962-.962a1 1 0 0 0 .125-1.262l-.867-1.302c.1-.208.19-.423.267-.645l1.533-.306A1 1 0 0 0 20 12.68v-1.36a1 1 0 0 0-.804-.981z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Settings;
//# sourceMappingURL=Settings.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Settings.js